module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ge-Ha-Ib-Ja.4ce47522.png";